var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { GrFilter } from 'react-icons/gr';
import api from '../../services/api';
import Filter from '../../components/Filter';
import useAuth from '../../hooks/useAuth';
import useTitle from '../../hooks/useTitle';
import { Table } from 'template/lib';
import styles from './styles.module.scss';
// =========================
// FORMAT HELPERS
// =========================
var formatDate = function (value) {
    if (!value)
        return '-';
    var date = new Date(value);
    if (isNaN(date.getTime()))
        return '-';
    return new Intl.DateTimeFormat('pt-BR').format(date);
};
var formatBoolean = function (value) { return (value ? 'Sim' : 'Não'); };
// =========================
// DATA MAPPER (DTO FRONT)
// =========================
var mapClientUpdateToTable = function (data) {
    return data.map(function (item) { return (__assign(__assign({}, item), { versionDate: formatDate(item.versionDate), updateDate: formatDate(item.updateDate), currentVersion: formatDate(item.currentVersion), updated: formatBoolean(item.updated) })); });
};
var ClientVersion = function () {
    var history = useHistory();
    var _a = useAuth(), login = _a.login, handleLogout = _a.handleLogout;
    var setTitle = useTitle().setTitle;
    var _b = useState([]), helps = _b[0], setHelps = _b[1];
    var _c = useState(1), page = _c[0], setPage = _c[1];
    var _d = useState(15), pageSize = _d[0], setPageSize = _d[1];
    var _e = useState(false), hasNext = _e[0], setHasNext = _e[1];
    var _f = useState(false), filter = _f[0], setFilter = _f[1];
    var _g = useState(0), totalPages = _g[0], setTotalPages = _g[1];
    var _h = useState(null), filterState = _h[0], setFilterState = _h[1];
    var _j = useState(false), loading = _j[0], setLoading = _j[1];
    var _k = useState([]), companies = _k[0], setCompanies = _k[1];
    var config = {
        headers: { Authorization: "Bearer " + (login === null || login === void 0 ? void 0 : login.token) }
    };
    // =========================
    // AUTH EFFECT
    // =========================
    useEffect(function () {
        setTitle('Gerenciamento de Versões de Atualização');
        if (!login) {
            history.replace('/');
            return;
        }
        if (Date.now() > login.expiresIn * 1000) {
            handleLogout();
            history.replace('/');
        }
    }, [login]);
    useEffect(function () {
        if (!(login === null || login === void 0 ? void 0 : login.token))
            return;
        api.get('/companies', config)
            .then(function (response) {
            setCompanies(response.data);
        })
            .catch(function (error) {
            console.error('Erro ao carregar clientes:', error);
        });
    }, [login]);
    // =========================
    // LOAD FILTER OPTIONS
    // =========================
    var filterVal = [
        {
            dataType: 'Select',
            fieldName: 'ClientId',
            fieldDisplay: 'Cliente',
            filedValue: '',
            options: companies.map(function (company) { return ({
                id: company.id,
                display: company.name
            }); }),
            customFilter: false
        },
        {
            dataType: 'Select',
            fieldName: 'Updated',
            fieldDisplay: 'Atualizado',
            filedValue: '',
            options: [
                { id: 1, display: 'Sim' },
                { id: 0, display: 'Não' }
            ],
            customFilter: false
        }
    ];
    // =========================
    // LOAD TABLE DATA
    // =========================
    useEffect(function () {
        if (!(login === null || login === void 0 ? void 0 : login.token))
            return;
        setLoading(true);
        var clientId = filterState === null || filterState === void 0 ? void 0 : filterState.ClientId;
        var updated = filterState === null || filterState === void 0 ? void 0 : filterState.Updated;
        var params = new URLSearchParams({
            page: String(page),
            pageSize: String(pageSize)
        });
        if (updated !== null && updated !== undefined && updated !== '') {
            params.append('Updated', String(updated));
        }
        var url = clientId
            ? "/client-update/history/" + clientId + "?" + params.toString()
            : "/client-update/history?" + params.toString();
        if (filterState) {
            Object.entries(filterState).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                if (key === 'ClientId')
                    return;
                if (value !== null && value !== undefined && value !== '') {
                    url += "&" + key + "=" + value;
                }
            });
        }
        api.get(url, {
            headers: { Authorization: "Bearer " + login.token }
        })
            .then(function (response) {
            var _a, _b, _c;
            var data = response.data;
            // A API pode devolver [] ou { items, total, page, pageSize }
            var items = Array.isArray(data) ? data : (_a = data === null || data === void 0 ? void 0 : data.items) !== null && _a !== void 0 ? _a : [];
            var total = Array.isArray(data) ? data.length : (_b = data === null || data === void 0 ? void 0 : data.total) !== null && _b !== void 0 ? _b : 0;
            var size = Array.isArray(data) ? pageSize : (data === null || data === void 0 ? void 0 : data.pageSize) || pageSize;
            var currentPage = Array.isArray(data) ? page : (_c = data === null || data === void 0 ? void 0 : data.page) !== null && _c !== void 0 ? _c : page;
            setHelps(mapClientUpdateToTable(items));
            var calculatedTotalPages = total > 0 ? Math.ceil(total / size) : 0;
            setTotalPages(calculatedTotalPages);
            setHasNext(currentPage < calculatedTotalPages);
        })
            .catch(function (error) {
            var _a;
            setHelps([]);
            setTotalPages(0);
            setHasNext(false);
            if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 401) {
                handleLogout();
                history.replace('/');
            }
            else {
                console.error('Erro ao carregar histórico:', error);
            }
        })
            .finally(function () { return setLoading(false); });
    }, [page, pageSize, filterState, login]);
    // =========================
    // UI CONFIG
    // =========================
    var lineBtnsWithoutAssginTo = [];
    var menuButtons = [
        {
            id: 3,
            icon: _jsx(GrFilter, {}, void 0),
            title: 'Filtrar',
            fn: function () { return setFilter(function (prev) { return !prev; }); }
        }
    ];
    var closeFilter = function () { return setFilter(false); };
    var resetPage = function () { return setPage(1); };
    // =========================
    // RENDER
    // =========================
    return (_jsxs("div", __assign({ className: styles.container }, { children: [filter && (_jsx("div", __assign({ className: "m-4" }, { children: _jsx(Filter, { page: resetPage, closer: closeFilter, data: filterVal, stateOfFilter: setFilterState }, void 0) }), void 0)), _jsx("div", __assign({ className: "" + (!filter && styles.content) }, { children: _jsx(Table, { setSize: setPageSize, size: pageSize, hasNext: hasNext, page: page, setPage: setPage, data: helps, totalPAges: totalPages, headerButtons: menuButtons, lineButton: lineBtnsWithoutAssginTo, loading: loading, title: "Atualiza\u00E7\u00F5es", columns: [
                        { label: 'Cliente', key: 'clientName' },
                        { label: 'Versão Atual', key: 'currentVersion' },
                        { label: 'Data da Atualização', key: 'updateDate' },
                        { label: 'Data da Versão', key: 'versionDate' },
                        { label: 'Atualizado', key: 'updated' },
                        { label: 'Descrição', key: 'comment', maxLenghtToShowSeeMore: 150 }
                    ] }, void 0) }), void 0)] }), void 0));
};
export default ClientVersion;
